import Api from 'services/Api';
import store from 'store';
import { get, set } from 'lodash';
import { configs } from 'config';
import { addTsToPredictions } from 'utils/time';

export const getUsers = (appId, after) => {
  const args = after
    ? `limit: ${configs().USERS_QUERY_LIMIT}, after: "${after}"`
    : `limit: ${configs().USERS_QUERY_LIMIT}`;
  const query = `query Root($app_id: String!) {
    app(id: $app_id) {
      id
      active_users(${args}) {
        paging {
          cursors {
            after
          }
        }
        slice {
          id
          event_history(latest: "1_days") {
            start
            end
            start_ts
            end_ts
            type
            ... on Stationary {
              location {
                significance
              }
            }
            ... on Transport {
              mode
            }
          }
          moment_history(latest: "1_days") {
            start
            end
            start_ts
            end_ts
            type
            moment_definition_id
            moment_definition {
              category
            }
          }
          location {
            longitude
            latitude
          }
          segments(status: ALPHA) {
            segment_definition_id
          }
          prediction_tree {
            events {
              start
              end
              type
              ... on StationaryPrediction {
                location_type
              }
              ... on TransportPrediction {
                mode
              }
            }
          }
          car_behavior {
            ... on UserCarBehavior {
              scores {
                ... on UserCarBehaviorScores {
                  past {
                    all {
                      smooth_v2
                      legal_v2
                      anticipative_v2
                      focus
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`;
  const variables = {
    app_id: appId,
  };

  return Api.query(query, variables)
    .then(res => {
      const userKey = 'body.data.app.active_users.slice';
      let users = get(res, userKey) || [];

      if (users.length) {
        // Add start_ts and end_ts to prediction_tree
        users = users.map(user => ({
          ...user,
          prediction_tree: {
            events: addTsToPredictions(get(user, 'prediction_tree.events', [])),
          },
        }));
        set(res, userKey, users);
      }

      return res;
    })
    .catch(err => err);
};

export const getUserById = id => {
  return store.state.audience.userMap[id];
};
